module.exports = __webpack_public_path__ + "static/media/sf-logo.dbddcc08.svg";